import React from "react";

const About = () => {
  return <div>About US</div>;
};

export default About;
